import Icon from '@passkeys/ui/icon';

export interface ExpandIconProps {
  size: number;
}

function ExpandIcon({ size }: ExpandIconProps) {
  return (
    <Icon
      className="text-[color:var(--collapsed-text-color,_theme(colors.black))] opacity-[--collapsed-icon-opacity,1]"
      name="caret-up-right-caret-down-left-from-center"
      size={size}
    />
  );
}

export default ExpandIcon;
